import { GET_ASSETS, GET_ASSET_DETAIL, GET_ACTIVITY_PERFORMANCE_ASSET_LIST, GET_ISO_CODE, RESET_REDUX_STATE } from "../constants";

const initState = {
  assetList: [],
  assetDetail: {},
  allAssets: [],
  isoCodeData: []
};

const assets = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ASSETS: {
      return {
        ...state,
        assetList: payload,
      };
    }
    case GET_ASSET_DETAIL: {
      return {
        ...state,
        assetDetail: payload,
      };
    }
    case GET_ACTIVITY_PERFORMANCE_ASSET_LIST: {
      return {
        ...state,
        allAssets: payload,
      };
    }

    case GET_ISO_CODE: {
      return {
        ...state,
        isoCodeData: payload
      }
    }

    case RESET_REDUX_STATE: {
      return initState
    }

    default:
      return state;
  }
};

export default assets;
